import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import axios from 'axios';
import Qs from 'qs';
import _ from 'lodash';

import Container from '@material-ui/core/Container';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import {KeyboardDatePicker} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';

import Conf from 'utils/Conf';
import Context from 'utils/Context';
import Pager from 'components/Pager';

import 'index.css';
import './Profile.scss';

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      user: {},
      passwordDialogOpen: false,
      currentPassword: '',
      newPassword: '',
    };
  }
  componentDidMount() {
    this.props.ed.addEventListener('userUpdate', this.userUpdate);
    this.userUpdate();
  }
  componentWillUnmount() {
    this.props.ed.removeEventListener('userUpdate', this.userUpdate);
  }
  userUpdate = () => {
    this.setState({user: _.cloneDeep(this.props.appState.user)});
  };

  setError = (name, value) => {
    const errors = this.state.errors;
    this.setState({
      errors: {
        ...errors,
        [name]: value,
      },
    });
  };
  handleFormSubmit = event => {
    event.preventDefault();
    this.setState({
      errors: {},
    });
    let errors = 0;
    if (this.state.user.pseudo.length < 4) {
      this.setError('pseudo', this.props.t('pseudo-obligatoire-4-caracteres-minimum'));
      errors++;
    }
    if (Object.keys(errors).length === 0) {
      let user = this.state.user;
      user._method = 'PATCH';
      axios.post(Conf.apiBaseUriLegacy + '/user/profile', Qs.stringify(user), {withCredentials: true}).then(res => {
        const data = res.data;
        if (data.status === 'success') {
          this.props.methods.getProfile();
        } else if (data.status === 'error') {
          this.setError('patch', data.error);
        }
      });
    }
  };
  handlePasswordSubmit = e => {
    e.preventDefault();
    this.setState({
      errors: {},
    });
    let errors = 0;
    if (this.state.newPassword.length < 5) {
      this.setError('newpass', this.props.t('votre-nouveau-mot-de-passe-doit-contenir-au-moins-5-caracteres'));
      errors++;
    }
    if (errors === 0) {
      var data = {
        password_current: this.state.currentPassword,
        password_new: this.state.newPassword,
        _method: 'PATCH',
      };
      axios.post(Conf.apiBaseUriLegacy + '/user/password', Qs.stringify(data), {withCredentials: true}).then(res => {
        const data = res.data;
        if (data.status === 'success') return this.setState({passwordChangeSuccess: true});
        else if (data.status === 'error') return this.setError('passwordChange', data.error);
      });
    }
  };
  handlePasswordDialogClose = () => {
    this.setState({passwordDialogOpen: false});
  };
  handlePasswordDialogOpen = () => {
    this.setState({passwordDialogOpen: true});
  };
  handleDateChange = (m, name) => {
    let value = m.format('YYYY-MM-DD HH:mm:ss');
    let user = this.state.user;
    user[name] = value;
    this.setState({user: user});
  };
  handleChange = event => {
    let {name, value, type} = event.target;
    const {user} = this.state;
    if (type === 'checkbox') {
      value = event.target.checked ? 1 : 0;
    }
    this.setState({
      user: {
        ...user,
        [name]: value,
      },
    });
  };
  handlePasswordChange = event => {
    let {name, value} = event.target;
    this.setState({[name]: value});
  };
  render() {
    const {t} = this.props;
    const {appState} = this.context;
    const {user, passwordChangeSuccess} = this.state;

    const shouldShowNewsletterCheckbox = appState.conf.NEWSLETTER_ENABLED;
    const updatePasswordIdx = passwordChangeSuccess ? 1 : 0;
    return (
      user && (
        <Paper>
          <form onSubmit={this.handleFormSubmit} noValidate autoComplete="off">
            <Container disableGutters>
              <Grid container spacing={0}>
                <Grid item xs={12} md={6}>
                  <DialogContent>
                    <TextField
                      onChange={this.handleChange}
                      type="text"
                      variant="filled"
                      fullWidth
                      margin="dense"
                      name="firstname"
                      label={t('prenom')}
                      value={user.firstname || ''}
                    />
                    <TextField
                      onChange={this.handleChange}
                      type="text"
                      margin="dense"
                      variant="filled"
                      fullWidth
                      name="lastname"
                      label={t('nom')}
                      value={user.lastname || ''}
                    />
                    <TextField
                      onChange={this.handleChange}
                      type="text"
                      margin="dense"
                      variant="filled"
                      fullWidth
                      name="pseudo"
                      label={t('pseudo')}
                      value={user.pseudo || ''}
                    />
                  </DialogContent>
                </Grid>
                <Grid item xs={12} md={6}>
                  <DialogContent>
                    <KeyboardDatePicker
                      autoOk
                      fullWidth
                      variant="inline"
                      margin="dense"
                      inputVariant="filled"
                      label={t('date-de-naissance')}
                      format="DD/MM/YYYY"
                      value={user.dob || null}
                      InputAdornmentProps={{position: 'start'}}
                      onChange={m => this.handleDateChange(m, 'dob')}
                    />
                    <FormControl variant="filled" fullWidth margin="dense">
                      <InputLabel id="select-gender">{t('genre')}</InputLabel>
                      <Select
                        id="select-gender"
                        fullWidth
                        margin="dense"
                        name="gender"
                        value={user.gender || ''}
                        onChange={this.handleChange}
                      >
                        <MenuItem value="male">{t('homme')}</MenuItem>
                        <MenuItem value="female">{t('femme')}</MenuItem>
                        <MenuItem value="other">{t('autre')}</MenuItem>
                      </Select>
                    </FormControl>
                    <div className="spacer"></div>
                    {!!shouldShowNewsletterCheckbox && (
                      <Grid container alignContent="center" alignItems="center">
                        <Grid item xs={2} md={1}>
                          <Checkbox
                            color="default"
                            checked={user.newsletter === 1}
                            onChange={this.handleChange}
                            name="newsletter"
                            inputProps={{'aria-label': 'primary Checkbox'}}
                          />
                        </Grid>
                        <Grid item xs={10} md={11}>
                          {t('je-souhaite-etre-tenu-informe-des-actualites-de-la-vingt-cinquieme-heure')}
                        </Grid>
                      </Grid>
                    )}
                  </DialogContent>
                </Grid>
              </Grid>
            </Container>
            <DialogActions>
              <Button color="primary" variant="outlined" onClick={this.handlePasswordDialogOpen}>
                {t('modifier-mon-mot-de-passe')}
              </Button>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={_.isEqual(this.state.user, this.props.appState.user)}
              >
                {t('mettre-a-jour')}
              </Button>
            </DialogActions>
          </form>
          <Dialog
            scroll="body"
            open={this.state.passwordDialogOpen}
            onClose={this.handlePasswordDialogClose}
            className="my-dialog"
          >
            <Pager
              pages={[
                <form noValidate autoComplete="off" onSubmit={this.handlePasswordSubmit}>
                  <DialogContent>
                    <TextField
                      fullWidth
                      variant="filled"
                      margin="dense"
                      value={this.state.currentPassword}
                      name="currentPassword"
                      type="password"
                      onChange={this.handlePasswordChange}
                      label={t('mot-de-passe-actuel')}
                    />
                    <TextField
                      name="newPassword"
                      fullWidth
                      variant="filled"
                      margin="dense"
                      value={this.state.newPassword}
                      type="password"
                      error={Boolean(this.state.errors.newpass)}
                      helperText={this.state.errors.newpass ? this.state.errors.newpass : t('5-caracteres-minimum')}
                      onChange={this.handlePasswordChange}
                      label={t('nouveau-mot-de-passe')}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      type="submit"
                      label={t('mot-de-passe')}
                      color="primary"
                      variant="contained"
                      disabled={this.state.currentPassword === '' || this.state.newPassword.length < 5}
                    >
                      {t('modifier')}
                    </Button>
                  </DialogActions>
                </form>,
                <React.Fragment>
                  <DialogContent>
                    <DialogContentText>{t('mot-de-passe-mis-a-jour')}</DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      type="submit"
                      label={t('mot-de-passe')}
                      color="primary"
                      variant="contained"
                      onClick={this.handlePasswordDialogClose}
                    >
                      {t('fermer')}
                    </Button>
                  </DialogActions>
                </React.Fragment>,
              ]}
              idx={updatePasswordIdx}
            />
          </Dialog>
        </Paper>
      )
    );
  }
}

Profile.contextType = Context;

export default withTranslation()(Profile);
